export const copyText = function(text) {
	if (navigator.clipboard) {
		navigator.clipboard.writeText(text);
	} else {
		alert(text);
	}
}

window.onload = () => {
    document.querySelectorAll("button.particleButton").forEach(btn => {
        let btnBg = btn.parentNode.querySelector(".particles")
        let initalListener = () => {
            btnBg.classList.add("animated")
            btn.removeEventListener("click", initalListener)
        }
        btn.addEventListener("click", initalListener)
    })
}
